import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { Menu, X, Search, Coffee } from 'lucide-react';
import { Button } from '@/components/ui/button';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const KOFI_URL = 'https://ko-fi.com/mirnalinivenkatraman';

export default function Navigation() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const location = useLocation();

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${API}/categories`);
      setCategories(response.data);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  const isActive = (path) => location.pathname === path;

  const staticLinks = [
    { path: '/books', label: "Children's Books" },
  ];

  const categoryLinks = categories.map(cat => ({
    path: `/gifts/${cat.slug}`,
    label: cat.name
  }));

  const navLinks = [...staticLinks, ...categoryLinks, { path: '/about', label: 'About' }];

  return (
    <nav className="sticky top-0 z-50 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-b border-border/50">
      <div className="container mx-auto px-6 md:px-12 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link
            to="/"
            className="font-heading text-2xl md:text-3xl font-light text-primary tracking-tight"
            data-testid="nav-logo"
          >
            what2gift
          </Link>

          {/* Right controls: search + hamburger (all screen sizes) */}
          <div className="flex items-center gap-1">
            <Link to="/search" data-testid="nav-search-button">
              <Button variant="ghost" size="icon">
                <Search className="h-5 w-5" />
              </Button>
            </Link>
            <button
              className="text-foreground p-2 -mr-2 transition-colors hover:text-primary"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              data-testid="menu-toggle"
              aria-label="Toggle menu"
            >
              {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Dropdown Menu */}
        {mobileMenuOpen && (
          <div className="mt-4 pb-2 grid gap-1 animate-in fade-in slide-in-from-top-2 duration-200" data-testid="nav-menu">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMobileMenuOpen(false)}
                className={`block font-body text-base py-2.5 px-3 rounded-md transition-colors ${
                  isActive(link.path)
                    ? 'text-primary font-semibold bg-secondary/60'
                    : 'text-muted-foreground hover:text-foreground hover:bg-secondary/40'
                }`}
                data-testid={`nav-${link.label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href={KOFI_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setMobileMenuOpen(false)}
              className="mt-1 flex items-center gap-2 font-body text-base py-2.5 px-3 rounded-md text-accent hover:bg-accent/10 transition-colors font-semibold"
              data-testid="nav-kofi"
            >
              <Coffee className="h-4 w-4" /> Support Us on Ko-fi
            </a>
          </div>
        )}
      </div>
    </nav>
  );
}